"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioAnalyzer = void 0;
/**
 * Implements an audio analyzer that provides audio stream data.
 * You must call connect() before using.
 */
class AudioAnalyzer {
    constructor(config) {
        this.context = (config === null || config === void 0 ? void 0 : config.context) || new AudioContext();
        this.analyser = this.context.createAnalyser();
        if (config === null || config === void 0 ? void 0 : config.fftSize) {
            this.analyser.fftSize = config.fftSize;
        }
    }
    get isConnected() {
        return this.audioStream !== undefined;
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.audioStream) {
                const mediaStream = yield getUserMedia();
                this.audioStream = this.context.createMediaStreamSource(mediaStream);
                this.audioStream.connect(this.analyser);
            }
        });
    }
    disconnect() {
        if (this.audioStream) {
            this.audioStream.disconnect(this.analyser);
            this.audioStream = undefined;
        }
    }
    /**
     * Copies the current waveform, or time-domain, data into an array. If an array is not specified it will create a new one.
     * @param array Optional array to copy to
     */
    getFloatTimeDomainData(array) {
        this.analyser.getFloatTimeDomainData(array || (array = new Float32Array(this.analyser.frequencyBinCount)));
        return array;
    }
    /**
     * Copies the current waveform, or time-domain, data into an array. If an array is not specified it will create a new one.
     * @param array Optional array to copy to
     */
    getByteTimeDomainData(array) {
        this.analyser.getByteTimeDomainData(array || (array = new Uint8Array(this.analyser.frequencyBinCount)));
        return array;
    }
    /**
     * Copies the current frequency data into an array. If an array is not specified it will create a new one.
     * @param array Optional array to copy to
     */
    getFloatFrequencyData(array) {
        this.analyser.getFloatFrequencyData(array || (array = new Float32Array(this.analyser.frequencyBinCount)));
        return array;
    }
    /**
     * Copies the current frequency data into an array. If an array is not specified it will create a new one.
     * @param array Optional array to copy to
     */
    getByteFrequencyData(array) {
        this.analyser.getByteFrequencyData(array || (array = new Uint8Array(this.analyser.frequencyBinCount)));
        return array;
    }
}
exports.AudioAnalyzer = AudioAnalyzer;
function getUserMedia() {
    return __awaiter(this, void 0, void 0, function* () {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            return yield navigator.mediaDevices.getUserMedia({ audio: true });
        }
        throw new Error('Audio recording not supported by your web browser');
    });
}
